import { useLayoutEffect, useRef, useState } from "react";

export default function useRibbonLabelShift(isRtl: boolean) {
  const ref = useRef<HTMLDivElement>(null);
  const [shift, setShift] = useState(0);

  useLayoutEffect(() => {
    if (!ref.current) return;
    const observer = new ResizeObserver(([entry]) => {
      const { inlineSize: w, blockSize: h } = entry.borderBoxSize[0];
      setShift(((w - h) / 2) * Math.SQRT1_2 * (isRtl ? -1 : 1));
    });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [isRtl]);

  return { ref, shift };
}
